// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/devices_franquias/salvar
 *
 * Creates or updates a WhatsApp device (device franquia).
 * If device_id is provided, updates existing; otherwise creates new.
 */
import { registerContract } from './validate'

export interface DevicesFranquias_SalvarInput {
device_id?: number
numero_whatsapp?: string
device_name?: string
device_token?: string
active?: number
provider_type?: string
franquia_ids?: number[]
}

registerContract('DevicesFranquias_SalvarInput', {
  device_id:       { type: 'number',  required: false },
  numero_whatsapp: { type: 'string',  required: false },
  device_name:     { type: 'string',  required: false },
  device_token:    { type: 'string',  required: false },
  active:          { type: 'number',  required: false },
  provider_type:   { type: 'string',  required: false },
  franquia_ids:    { type: 'array',   required: false },
})
